import { Mail, MapPin, Phone, Facebook, Instagram } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const Contact = () => {
  const socialLinks = [
    { icon: <Facebook className="w-5 h-5" />, href: "https://www.facebook.com/maitechcomp", label: "Facebook" },
    { icon: <Instagram className="w-5 h-5" />, href: "https://www.instagram.com/maitechcorp", label: "Instagram" },
    { 
      icon: <img src="/logo/tiktok.png" alt="TikTok" className="w-5 h-5 object-contain bg-white" />, 
      href: "https://www.tiktok.com/@maitechcorp", 
      label: "TikTok" 
    },
    { 
      icon: <img src="/logo/zalo.svg" alt="Zalo" className="w-5 h-5 object-contain" />, 
      href: "https://zalo.me/2617993914803033984", 
      label: "Zalo" 
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow container mx-auto px-4 py-24">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-4xl font-bold text-center mb-8">Contact Us</h1>
          
          <div className="bg-maitech-800 p-8 rounded-lg space-y-8 max-w-2xl mx-auto">
            <h2 className="text-2xl font-semibold mb-6 text-center">Get in Touch</h2>
            
            <div className="flex items-start space-x-4">
              <MapPin className="w-5 h-5 text-primary flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-medium">Address</h3>
                <p className="text-gray-400">Tầng 5, 262/4 Lạc Long Quân, Phường 10, Quận 11, Thành phố Hồ Chí Minh, Việt Nam.</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-4">
              <Phone className="w-5 h-5 text-primary" />
              <div>
                <h3 className="font-medium">Phone</h3>
                <p className="text-gray-400">0777900721</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-4">
              <Mail className="w-5 h-5 text-primary" />
              <div>
                <h3 className="font-medium">Email</h3>
                <p className="text-gray-400">maitechnologies1@gmail.com</p>
              </div>
            </div>

            {/* Social Media Links */}
            <div className="pt-6 border-t border-maitech-700">
              <h3 className="font-medium mb-4 text-center">Connect With Us</h3>
              <div className="grid grid-cols-2 gap-4">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-primary transition-colors flex items-center space-x-3 p-3 rounded-lg border border-maitech-700 hover:border-primary"
                  >
                    <span className="flex items-center justify-center w-6 h-6">
                      {social.icon}
                    </span>
                    <span>{social.label}</span>
                  </a>
                ))}
              </div>
            </div>
            
            <div className="text-center text-gray-400 pt-4">
              <p>We're available 24/7 to help with your questions and needs.</p>
              <p className="mt-2">Looking forward to partnering with you!</p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Contact;
